import api from "./api";

export const createEmployee = (employee) => {
  return api.post("/employees", employee);
};

export const updateEmployee = (id, employee) => {
  return api.put(`/employees/${id}`, employee);
};

export const getEmployeeByAdminId = (id) => {
  return api.get(`/employees/by-adminId/${id}`);
};

export const deleteEmployee = (id, adminId) => {
  return api.delete(`/employees/${id}?adminId=${adminId}`);
}

export const loginEmployee = (employeeLoginRequest) => {
  return api.post("/employees/login", employeeLoginRequest);
};

export const updateEmployeePassword = async (employeeId, passwordData) => {
  return api.put(`/employees/password/${employeeId}`, passwordData);
};
